module.exports = __webpack_public_path__ + "src/fonts/open-sans-v17-latin-600.woff";